/**
 * VRG-680 — the launch switches the API reports on `GET /features`
 * (`apps/api/src/infrastructure/controllers/features.public.controller.ts`). Mirrors its
 * `FeatureSwitches` key for key; the two MUST change together.
 *
 * Read at RUN time from the API, never a build-time constant, so flipping `REFERRALS_ENABLED`
 * on the API needs no frontend redeploy.
 *
 * Dependency-free on purpose: the platform guard spec loads this under node's own runner.
 */
export interface FeatureSwitches {
  /** "Refer & earn" (VRG-649). */
  referrals: boolean
}

/**
 * FAIL CLOSED. Until the API has answered (and if it never does) every switch reads off,
 * so a slow or failed `/features` call can only ever HIDE a programme, never expose one.
 */
export const FEATURE_SWITCHES_OFF: FeatureSwitches = { referrals: false }

/** Only an explicit `true` from the API turns referrals on. */
export const isReferralsLive = (switches: Partial<FeatureSwitches> | null | undefined): boolean =>
  switches?.referrals === true

/** Shown on the internal staff views while the programme is off (they stay readable). */
export const REFERRALS_SWITCHED_OFF_LABEL = 'Referrals are switched off'
export const REFERRALS_SWITCHED_OFF_DETAIL =
  'Brands cannot see Refer & earn, send invites or earn credits until REFERRALS_ENABLED is turned on for the API. What is shown here is history.'
